// document.addEventListener('DOMContentLoaded', function () {
//     const modalTriggerBtns = document.querySelectorAll('[data-toggle="modal"]');

//     modalTriggerBtns.forEach(btn => {
//         btn.addEventListener('click', function () {
//             const targetSelector = btn.getAttribute('data-target');
//             const targetModal = document.querySelector(targetSelector);

//         // すべてのモーダルを閉じる
//         const openedModals = document.querySelectorAll('.modal.show');
//         openedModals.forEach(modal => {
//             const modalInstance = bootstrap.Modal.getInstance(modal);
//             if (modalInstance) modalInstance.hide();
//         });

//         // 指定のモーダルを開く
//         if (targetModal) {
//             const newModal = new bootstrap.Modal(targetModal);
//             newModal.show();
//         }
//         });
//     });
// });


// document.addEventListener('DOMContentLoaded', function () {
//     const modalTriggerBtns = document.querySelectorAll('[data-toggle="modal"]');

//     modalTriggerBtns.forEach(btn => {
//         btn.addEventListener('click', function () {
//             const targetSelector = btn.getAttribute('modal--job-entry');
//             const targetModal = document.querySelector(targetSelector);

//         //  クリックされたボタンが属するモーダルを取得
//         const currentModal = btn.closest('.modal');
//         if (currentModal) {
//             const currentInstance = bootstrap.Modal.getInstance(currentModal);
//                 if (currentInstance) {
//                 currentInstance.hide();
//                 } else {
//             // モーダルインスタンスがまだない場合、新しく作って閉じる
//             const tempInstance = new bootstrap.Modal(currentModal);
//             tempInstance.hide();
//             }
//         }

//         //  指定されたモーダルを開く
//         if (targetModal) {
//             const newModal = new bootstrap.Modal(targetModal);
//             newModal.show();
//             }
//         });
//     });
// });


/**
 * @file マイページのモーダル設定
*
*/


/**
  * @classname MypageModal
  * @classdesc マイページモーダル設定
  */
// export default class MypageModal {

    // /**
    //  * @constructor
    //  */

//     constructor() {
//         // 試し
//         console.log('成功');
//         console.log(typeof bootstrap?.Modal);

//         document.addEventListener('DOMContentLoaded', function () {
//             // 電話予約フォームが立ち上がったら、選択画面のモーダル（modal--mtg-appointment）が非表示になる
//             // const mtgAppointmentModal = document.getElementById('modal--mtg-appointment');
//             // const telMenuModal = document.getElementById('modal--tel-menu');

//             // if (telMenuModal && mtgBtn) {
//             //     mtgBtn.addEventListener('click', function () {
//             //         telMenuModal.style.display = 'none';
//             //     });
//             // }

//             const mtgAppointmentModal = document.getElementById('modal--mtg-appointment');
//             const telMenuModal = document.getElementById('modal--tel-menu');

//             if (mtgAppointmentModal && telMenuModal) {
//             // mtgAppointmentModal が表示状態になったタイミングで telMenuModal を非表示にする
//             const observer = new MutationObserver(() => {
//                 const isVisible = window.getComputedStyle(mtgAppointmentModal).display !== 'none';
//                 if (isVisible) {
//                 telMenuModal.style.display = 'none';
//                 }
//             });

//             observer.observe(mtgAppointmentModal, { attributes: true, attributeFilter: ['style', 'class'] });
//             }

//             // if (mtgAppointmentModal && telMenuModal) {
//             //     mtgAppointmentModal.addEventListener('show.bs.modal', function () {
//             //     const bsModal = bootstrap.Modal.getInstance(telMenuModal) || new bootstrap.Modal(telMenuModal);
//             //     bsModal.hide();
//             //     });
//             // }

//             // デフォルトのmodal--job-entry-initが表示されてしまっている気がするので閉じてみる
// 			const defaultModal = document.querySelector('.modal--job-entry');
//             if (defaultModal) {
//                 defaultModal.style.display = 'none'; // 完全非表示
//                 defaultModal.classList.remove('is-active'); // 他のJSが使っている表示クラスも外す
//             }

//             // modal--job-entry-init3だけ閉じておく（最初から表示されてるのがこれなら...）
// 			const targetModal = document.getElementById('modal--job-entry-init3');
// 			if (targetModal && targetModal.classList.contains('show')) {
// 				const modalInstance = bootstrap.Modal.getInstance(targetModal);
// 				if (modalInstance) {
// 					modalInstance.hide();
// 				} else {
// 					const newInstance = new bootstrap.Modal(targetModal);
// 					newInstance.hide();
// 				}
// 			}

// 			// modal--job-entry-init3だけ開く
// 			const init3Btns = document.querySelectorAll('[data-target="#modal--job-entry-init3"]');
// 			init3Btns.forEach(btn => {
// 				btn.addEventListener('click', function () {
// 					const targetModal = document.querySelector('#modal--job-entry-init3');

// 					// 他モーダルを閉じる（任意）
// 					const openedModals = document.querySelectorAll('.modal.show');
// 					openedModals.forEach(modal => {
// 						const modalInstance = bootstrap.Modal.getInstance(modal);
// 						if (modalInstance) modalInstance.hide();
// 					});

// 					if (targetModal) {
// 						const newModal = new bootstrap.Modal(targetModal);
// 						newModal.show();
// 					}
// 				});
// 			});
// 		});
//     }
//     //     $('#modal--job-entry').on('show.bs.modal', function (event) {
//     //         const $trigger = $(event.relatedTarget); // モーダルを開いたトリガーを取得
//     //         const $mailBtn = $(this).find('.js-mail-trigger');
        
//     //         if ($trigger.data('from') === 'tel-menu') {
//     //             $mailBtn.attr('data-mail-id', '3');
//     //         } else {
//     //             $mailBtn.attr('data-mail-id', '1');
//     //         }
        
//     //         // モーダルが開くたびに、MailerSettingsを再初期化
//     //         new MailerSettings($mailBtn);
//     //     });
// 	// }
// }
// $(document).ready(function () {
// 	$('#modal--job-entry').on('show.bs.modal', function (event) {
// 		const $trigger = $(event.relatedTarget);
// 		const $mailBtn = $(this).find('.js-mail-trigger');

// 		if ($trigger.data('from') === 'tel-menu') {
// 			$mailBtn.attr('data-mail-id', '3');
// 		} else {
// 			$mailBtn.attr('data-mail-id', '1');
// 		}

// 		new MailerSettings($mailBtn);
// 	});
// });



// ここから試し

export default class MypageModal {

    /**
     * @constructor
     */

	constructor() {
		// console.log('成功');

		document.addEventListener('DOMContentLoaded', () => {
			const mtgAppointmentModal = document.getElementById('modal--mtg-appointment');
			const telMenuModal = document.getElementById('modal--tel-menu');

			// mtgAppointmentModal が表示されたら telMenuModal を非表示に
			if (mtgAppointmentModal && telMenuModal) {
				const observer = new MutationObserver(() => {
					const isVisible = window.getComputedStyle(mtgAppointmentModal).display !== 'none';
					if (isVisible) {
						telMenuModal.style.display = 'none';
						telMenuModal.classList.remove('is-active', 'show');
					}
				});
				observer.observe(mtgAppointmentModal, { attributes: true, attributeFilter: ['style', 'class'] });
			}

			// デフォルトのモーダルを非表示にする
			const defaultModal = document.querySelector('.modal--job-entry');
			if (defaultModal) {
				defaultModal.style.display = 'none';
				defaultModal.classList.remove('is-active', 'show');
			}

			// // init3モーダルを最初に非表示にする
			// const targetModal = document.getElementById('modal--job-entry-init3');
			// if (targetModal && targetModal.classList.contains('show')) {
			// 	targetModal.style.display = 'none';
			// 	targetModal.classList.remove('is-active', 'show');
			// }

			// [data-target="#modal--job-entry-init3"] をクリックしたらモーダルが開く
			const init3Btns = document.querySelectorAll('[data-target="#modal--job-entry-init3"]');
			init3Btns.forEach(btn => {
				btn.addEventListener('click', (e) => {
					e.preventDefault();
					const targetModal = document.querySelector('#modal--job-entry-init3');

					// 他モーダルを全て非表示
					const openedModals = document.querySelectorAll('.modal.show, .modal.is-active');
					openedModals.forEach(modal => {
						modal.style.display = 'none';
						modal.classList.remove('show', 'is-active');
					});

					// init3モーダルを表示
					if (targetModal) {
						targetModal.style.display = 'block';
						targetModal.classList.add('show');
					}
				});
			});

			// MailerSettings の切り替え
			const modalJobEntry = document.getElementById('modal--job-entry');
			if (modalJobEntry) {
				const observer = new MutationObserver(() => {
					const isVisible = window.getComputedStyle(modalJobEntry).display !== 'none';
					if (isVisible) {
						const trigger = document.activeElement; // フォーカスのある要素をトリガーとみなす
						const mailBtn = modalJobEntry.querySelector('.js-mail-trigger');

						if (trigger && trigger.dataset.from === 'tel-menu') {
							mailBtn?.setAttribute('data-mail-id', '3');
						} else {
							mailBtn?.setAttribute('data-mail-id', '1');
						}

						new MailerSettings(mailBtn);
					}
				});
				observer.observe(modalJobEntry, { attributes: true, attributeFilter: ['style', 'class'] });
			}
		});
	}
}